import React from 'react';
import UsersTable from '../components/UsersTable';

const CompletedUsers = ({ users, setUsers }) => (
  <div>
    <h1 className='title-page'>Completed Users</h1>
    <UsersTable users={users} setUsers={setUsers} />
  </div>
);

export default CompletedUsers;
